export var skipToken = Symbol.for("apollo.skipToken");
//# sourceMappingURL=constants.js.map